//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import camItem from '~/components/content/cam/cam_new_card.vue';

export default {
  name: 'highlightedCams',
  props: {
    cams: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    camItem,
  },
};
